import { ICompoundFilterItem } from "../../../../shared/scripts/dropdown-functions";


export class ExpertiseArea implements ICompoundFilterItem {

    id: string;
    category: string;
    value: string;

    constructor(id: string, category: string, value: string) {
        this.id = id;
        this.category = category;
        this.value = value;
    }

    static GetExpertiseQuestionCategories(): string[] {
        return ["research", "virus", "vaccine", "antibody", "animalmodel", "management", "quality", "humantrial"];
    }

    static GetExpertiseAreas(): ExpertiseArea[] {
        let areas: ExpertiseArea[] = [];

        areas.push(new ExpertiseArea("research1", "research", "AI/Machine Learning"));
        areas.push(new ExpertiseArea("research2", "research", "Animal Models"));
        areas.push(new ExpertiseArea("research3", "research", "Antibody Development/Testing"));
        areas.push(new ExpertiseArea("research4", "research", "Antiviral Development/Testing"));
        areas.push(new ExpertiseArea("research5", "research", "Assay Development"));
        areas.push(new ExpertiseArea("research6", "research", "Basic Research"));
        areas.push(new ExpertiseArea("research7", "research", "Behavioral Science"));
        areas.push(new ExpertiseArea("research8", "research", "Bioethics"));
        areas.push(new ExpertiseArea("research9", "research", "Bioinformatics"));
        areas.push(new ExpertiseArea("research10", "research", "Biosafety/Biosecurity"));
        areas.push(new ExpertiseArea("research11", "research", "Biostatistics"));
        areas.push(new ExpertiseArea("research12", "research", "Climate Science"));
        areas.push(new ExpertiseArea("research13", "research", "Clinic/Hospital Patient Care"));
        areas.push(new ExpertiseArea("research14", "research", "Clinical Diagnostics"));
        areas.push(new ExpertiseArea("research15", "research", "Clinical Research"));
        areas.push(new ExpertiseArea("research16", "research", "CMC/Process Development "));
        areas.push(new ExpertiseArea("research17", "research", "Computational Biology"));
        areas.push(new ExpertiseArea("research18", "research", "Data Science"));
        areas.push(new ExpertiseArea("research19", "research", "Data Stewardship"));
        areas.push(new ExpertiseArea("research20", "research", "Ecology/Environmental Science"));
        areas.push(new ExpertiseArea("research21", "research", "Entomology"));
        areas.push(new ExpertiseArea("research22", "research", "Epidemiology"));
        areas.push(new ExpertiseArea("research23", "research", "Geneticist"));
        areas.push(new ExpertiseArea("research24", "research", "Genomic/Sequence Analysis"));
        areas.push(new ExpertiseArea("research25", "research", "Geospatial Modeling"));
        areas.push(new ExpertiseArea("research26", "research", "High Containment Research"));
        areas.push(new ExpertiseArea("research27", "research", "Immunology"));
        areas.push(new ExpertiseArea("research28", "research", "Microbiology"));
        areas.push(new ExpertiseArea("research29", "research", "Molecular Biology"));
        areas.push(new ExpertiseArea("research30", "research", "Pathogen Surveillance"));
        areas.push(new ExpertiseArea("research31", "research", "Pharmacology"));
        areas.push(new ExpertiseArea("research32", "research", "Pre-clinical: Efficacy "));
        areas.push(new ExpertiseArea("research33", "research", "Pre-clinical: Toxicology"));
        areas.push(new ExpertiseArea("research34", "research", "Protein Scientist"));
        areas.push(new ExpertiseArea("research45", "research", "Public Health"));
        areas.push(new ExpertiseArea("research35", "research", "Quality Assurance/Control"));
        areas.push(new ExpertiseArea("research36", "research", "Regulatory Affairs"));
        areas.push(new ExpertiseArea("research37", "research", "Select Agent Research"));
        areas.push(new ExpertiseArea("research38", "research", "Structural Biologist"));
        areas.push(new ExpertiseArea("research39", "research", "Toxicology"));
        areas.push(new ExpertiseArea("research40", "research", "Translational Research"));
        areas.push(new ExpertiseArea("research41", "research", "Vaccine Development/Testing"));
        areas.push(new ExpertiseArea("research42", "research", "Vector Control"));
        areas.push(new ExpertiseArea("research43", "research", "Veterinary Medicine"));
        areas.push(new ExpertiseArea("research44", "research", "Virology"));

        areas.push(new ExpertiseArea("virus1", "virus", "Arenaviridae"));
        areas.push(new ExpertiseArea("virus2", "virus", "Flaviviridae"));
        areas.push(new ExpertiseArea("virus3", "virus", "Hantaviridae"));
        areas.push(new ExpertiseArea("virus4", "virus", "Nairoviridae"));
        areas.push(new ExpertiseArea("virus5", "virus", "Paramyxoviridae"));
        areas.push(new ExpertiseArea("virus6", "virus", "Peribunyaviridae"));
        areas.push(new ExpertiseArea("virus7", "virus", "Phenuiviridae"));
        areas.push(new ExpertiseArea("virus8", "virus", "Picornaviridae"));
        areas.push(new ExpertiseArea("virus9", "virus", "Togaviridae"));
        areas.push(new ExpertiseArea("virus10", "virus", "Adenoviridae"));
        areas.push(new ExpertiseArea("virus11", "virus", "Asfarviridae"));
        areas.push(new ExpertiseArea("virus12", "virus", "Astroviridae"));
        areas.push(new ExpertiseArea("virus13", "virus", "Birnaviridae"));
        areas.push(new ExpertiseArea("virus14", "virus", "Caliciviridae"));
        areas.push(new ExpertiseArea("virus15", "virus", "Coronaviridae"));
        areas.push(new ExpertiseArea("virus16", "virus", "Filoviridae"));
        areas.push(new ExpertiseArea("virus17", "virus", "Matonaviridae"));
        areas.push(new ExpertiseArea("virus18", "virus", "Orthomyxoviridae"));
        areas.push(new ExpertiseArea("virus19", "virus", "Papillomaviridae"));
        areas.push(new ExpertiseArea("virus20", "virus", "Parvoviridae"));
        areas.push(new ExpertiseArea("virus21", "virus", "Phenuiviridae"));
        areas.push(new ExpertiseArea("virus22", "virus", "Polyomaviridae"));
        areas.push(new ExpertiseArea("virus23", "virus", "Poxviridae"));
        areas.push(new ExpertiseArea("virus24", "virus", "Reoviridae"));
        areas.push(new ExpertiseArea("virus25", "virus", "Retroviridae"));
        areas.push(new ExpertiseArea("virus26", "virus", "Rhabdoviridae"));

        areas.push(new ExpertiseArea("vaccine1", "vaccine", "Adjuvented"));
        areas.push(new ExpertiseArea("vaccine2", "vaccine", "DNA"));
        areas.push(new ExpertiseArea("vaccine3", "vaccine", "Lipid Nanoparticle"));
        areas.push(new ExpertiseArea("vaccine4", "vaccine", "Microneedle"));
        areas.push(new ExpertiseArea("vaccine5", "vaccine", "Modified RNA"));
        areas.push(new ExpertiseArea("vaccine6", "vaccine", "Nanoparticle"));
        areas.push(new ExpertiseArea("vaccine7", "vaccine", "Recombinant/Chimeric Virus"));
        areas.push(new ExpertiseArea("vaccine8", "vaccine", "Recombinant/Subunit Protein"));
        areas.push(new ExpertiseArea("vaccine9", "vaccine", "Self-amplifying RNA"));
        areas.push(new ExpertiseArea("vaccine10", "vaccine", "Vectored Gene"));
        areas.push(new ExpertiseArea("vaccine11", "vaccine", "Virus-Like Particle"));

        
        areas.push(new ExpertiseArea("antibody1", "antibody", "Cross Reactive"));
        areas.push(new ExpertiseArea("antibody2", "antibody", "Human Monoclonal"));
        areas.push(new ExpertiseArea("antibody3", "antibody", "Multispecific"));
        areas.push(new ExpertiseArea("antibody4", "antibody", "Nanobodies"));
        areas.push(new ExpertiseArea("antibody5", "antibody", "Nanoparticle"));
        areas.push(new ExpertiseArea("antibody6", "antibody", "Phage Display"));
        areas.push(new ExpertiseArea("antibody7", "antibody", "Transgenic Mouse"));
        areas.push(new ExpertiseArea("antibody8", "antibody", "Fc-Optimization"));


        areas.push(new ExpertiseArea("animalmodel1", "animalmodel", "Bats"));
        areas.push(new ExpertiseArea("animalmodel2", "animalmodel", "Camel"));
        areas.push(new ExpertiseArea("animalmodel3", "animalmodel", "Ferrets"));
        areas.push(new ExpertiseArea("animalmodel4", "animalmodel", "Guinea Pigs"));
        areas.push(new ExpertiseArea("animalmodel5", "animalmodel", "Hamsters"));
        areas.push(new ExpertiseArea("animalmodel6", "animalmodel", "Llama"));
        areas.push(new ExpertiseArea("animalmodel7", "animalmodel", "Mice (HumanIzed)"));
        areas.push(new ExpertiseArea("animalmodel8", "animalmodel", "Mice (Knockout)"));
        areas.push(new ExpertiseArea("animalmodel9", "animalmodel", "Mice (Transgenic)"));
        areas.push(new ExpertiseArea("animalmodel10", "animalmodel", "Mice (Wild-type)"));
        areas.push(new ExpertiseArea("animalmodel11", "animalmodel", "Non-Human Primates"));
        areas.push(new ExpertiseArea("animalmodel12", "animalmodel", "Pigs"));
        areas.push(new ExpertiseArea("animalmodel13", "animalmodel", "Rats"));
        areas.push(new ExpertiseArea("animalmodel14", "animalmodel", "Sheep"));
        areas.push(new ExpertiseArea("animalmodel15", "animalmodel", "Tree Shrews"));

        areas.push(new ExpertiseArea("management1", "management", "Biosafety/Biosecurity"));
        areas.push(new ExpertiseArea("management2", "management", "Clinical Trial Support "));
        areas.push(new ExpertiseArea("management3", "management", "Data Stewardship"));
        areas.push(new ExpertiseArea("management4", "management", "Financial Management"));
        areas.push(new ExpertiseArea("management5", "management", "Grants/Contract Management"));
        areas.push(new ExpertiseArea("management6", "management", "Legal Affairs"));
        areas.push(new ExpertiseArea("management7", "management", "Program/Project Management"));
        areas.push(new ExpertiseArea("management8", "management", "Quality Assurance/Control"));

        areas.push(new ExpertiseArea("quality1", "quality", "Clinical Laboratory Improvement Amendments (CLIA)"));
        areas.push(new ExpertiseArea("quality2", "quality", "College of American Pathologists (CAP)"));
        areas.push(new ExpertiseArea("quality3", "quality", "Dual Use Research of Concern (DURC)"));
        areas.push(new ExpertiseArea("quality4", "quality", "FDA/IND/BLA  Submission"));
        areas.push(new ExpertiseArea("quality5", "quality", "Good Laboratory Practices (GLP)"));
        areas.push(new ExpertiseArea("quality6", "quality", "Good Manufacturing Practices (GMP)"));
        areas.push(new ExpertiseArea("quality7", "quality", "HHS P3CO Framework (Potential Pandemic Pathogens)"));
        areas.push(new ExpertiseArea("quality8", "quality", "International Air Transport Association (IATA)"));
        areas.push(new ExpertiseArea("quality9", "quality", "International Organization for Standardization (ISO)"));
        areas.push(new ExpertiseArea("quality10", "quality", "US CDC Federal Select Agent Program"));

        areas.push(new ExpertiseArea("humantrial1", "humantrial", "Observational Cohort Studies"));
        areas.push(new ExpertiseArea("humantrial2", "humantrial", "Longitudinal Cohort Studies"));
        areas.push(new ExpertiseArea("humantrial3", "humantrial", "Randomized Controlled Trials"));
        areas.push(new ExpertiseArea("humantrial4", "humantrial", "Case-Control Studies"));
        areas.push(new ExpertiseArea("humantrial5", "humantrial", "Clinical Trials: Phase I"));
        areas.push(new ExpertiseArea("humantrial6", "humantrial", "Clinical Trials: Phase II"));
        areas.push(new ExpertiseArea("humantrial7", "humantrial", "Clinical Trials: Phase III"));
        areas.push(new ExpertiseArea("humantrial8", "humantrial", "Clinical Trials: Phase IV"));


        return areas;
    }
}